import { z } from 'zod';

/** UTC offset written as ±HH:MM, e.g. "-07:00". */
export const utcOffsetSchema = z.string().regex(/^[+-]\d{2}:\d{2}$/);

/**
 * British Columbia moved to permanent UTC−7 in 2026 (tzdata 2026b).
 * A server or database that disagrees has outdated time-zone data.
 */
export const EXPECTED_VANCOUVER_OFFSET = '-07:00';
export const MIN_TZDATA_VERSION = '2026b';

export const healthResponseSchema = z.object({
  status: z.enum(['ok', 'degraded']),
  version: z.string(),
  checkedAt: z.iso.datetime(),
  db: z.object({
    ok: z.boolean(),
    postgresVersion: z.string().nullable(),
    migrations: z.number().int().nonnegative().nullable(),
    error: z.string().nullable(),
  }),
  time: z.object({
    ok: z.boolean(),
    nodeTzdata: z.string().nullable(),
    vancouverOffsetNode: utcOffsetSchema.nullable(),
    vancouverOffsetDb: utcOffsetSchema.nullable(),
    problems: z.array(z.string()),
  }),
});

export type HealthResponse = z.infer<typeof healthResponseSchema>;
